import { LayerDefinitionDc, GeometryType } from "@evergis/api";

import { SchemaParsed } from "../../../../evergis/core/import/parseSchema";

const getObjectDefinitions = (items: SchemaParsed["children"], geometryType: GeometryType): LayerDefinitionDc[] => {
  const result: LayerDefinitionDc[] = [];

  items.forEach(item => {
    if (item.layerDefinition?.geometryType === geometryType) {
      result.push(item.layerDefinition);
    }
    if (item.children?.length) {
      result.push(...getObjectDefinitions(item.children, geometryType));
    }
  });

  return result;
};

export const getLayerDefinitions = (dataSchema: SchemaParsed[], geometryType: GeometryType): LayerDefinitionDc[] => {
  const result: LayerDefinitionDc[] = [];

  dataSchema.forEach(item => {
    result.push(...getObjectDefinitions(item.children, geometryType));
  });

  return result;
};
